import { definePage, type PluginWebManifest } from '@reflex/plugin-api/web';

/**
 * Configure → Company → Security.
 *
 * The page owns both halves of enterprise identity: the company's OIDC
 * connection, shared by every organization it owns, and this organization's
 * IdP binding — which issuer it trusts and which client applications that
 * trust extends to. It lives with the OIDC plugin rather than in the host app
 * because neither is meaningful unless enterprise sign-in is composed — a
 * deployment without this plugin has no issuer to trust, and should not carry
 * a nav row offering to bind one.
 *
 * The path sits under `/configure/company/` because that is whose settings
 * these are. It could not before: the company had no URL namespace, so the
 * page was contributed under `/configure/organization/...` and only the host
 * mapping said it was company-owned. Now the two agree. The host still maps
 * (group, path) to a Configure section, so the nav row's group and label stay
 * `CONFIGURE_SECTION_MAP`'s to decide, and `group` stays `'organization'`
 * because the plugin union is deliberately not widened. The old path is
 * redirected by the host (`LEGACY_ENTERPRISE_AUTHORIZATION_PATH`).
 */
const page = definePage({
  path: '/configure/company/security',
  label: 'Security',
  icon: 'KeyRound',
  group: 'organization',
  componentPath: '@reflex/plugin-auth-oidc/web/EnterpriseAuthorizationPage',
  description:
    'Your company’s identity provider connection, and the applications it may authorize.',
});

export const oidcAuthWeb: PluginWebManifest = page.web;
